import 'url-search-params-polyfill';
import { useLocation } from 'react-router-dom';

function useSearchParamsQuery() {
    return new URLSearchParams(useLocation().search);
}

export default useSearchParamsQuery;